export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12784.5f58afa0.jpg";